module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Mary-Queen-of-Scots.2d357ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Mary-Queen-of-Scots.jpg
// module id = inv8
// module chunks = 0